<template>
  <div class="pt20">
    <!-- Your content here -->
    <a-tabs>
      <a-tab-pane key="1" :tab="$t('admin.headerFooter.tabs.header')" @change="callback" forceRender="true">
        <Header ref="header"></Header>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('admin.headerFooter.tabs.footer')" forceRender="true">
        <Footer ref="footer"></Footer>
      </a-tab-pane>
      <a-tab-pane key="3" :tab="$t('admin.headerFooter.tabs.other')" forceRender="true">
        <Other ref="other"></Other>
      </a-tab-pane>
    </a-tabs>
    <div class="save">
      <a-button type="primary" @click="handleSubmit">{{ $t('admin.headerFooter.submit') }}</a-button>
    </div>
  </div>
</template>

<script>
import Header from './header.vue'
import Footer from './footer.vue'
import Other from './other.vue'
import { columnHeaderFooter, columnHeaderFooterDetail } from '@/api/admin'
export default {
  name: 'HeaderFooter',
  components: {
    Header,
    Footer,
    Other
  },
  data() {
    return {
      type: 'header'
      // Your data here
    }
  },
  methods: {
    // Your methods here
    async handleSubmit() {
      // localStorage.header = JSON.stringify({
      //   header: this.$refs.header.form,
      //   footer: this.$refs.footer.form,
      //   other: this.$refs.other.form
      // })
      if (!this.$refs.header.form.logoUrl) {
        this.$message.error(this.$t('admin.headerFooter.messages.logoRequired'))
        return
      }
      await columnHeaderFooter({
        id: this.id,
        content: JSON.stringify({
          header: this.$refs.header.form,
          footer: this.$refs.footer.form,
          other: this.$refs.other.form
        })
      })
      this.$message.success(this.$t('admin.headerFooter.messages.saveSuccess'))
    },
    async getHeaderFooter() {
      const { data } = await columnHeaderFooterDetail()
      console.log(data)
      const content = JSON.parse(data.content)
      Object.assign(this.$refs.header.form, content.header)
      Object.assign(this.$refs.footer.form, content.footer)
      Object.assign(this.$refs.other.form, content.other)
      this.id = data.id
    }
  },
  computed: {
    // Your computed properties here
  },
  mounted() {
    this.getHeaderFooter()
    // Your mounted hook logic here
  }
}
</script>

<style lang="less" scoped>
/* Your styles here */
/deep/ .ant-tabs-top .ant-tabs-ink-bar-animated{
  display: none !important;
}
/deep/ .ant-tabs-bar{
  border: none;
}
/deep/ .ant-tabs-nav{
  background: #EDF3FA;
  border-radius: 6px;
  .ant-tabs-tab{
    color: #6B738C;
    margin-right: 0;
    padding: 10px 27px;
  }
  .ant-tabs-tab-active{
    color: #FFF;
    background-color: #F27529;
    border-radius: 6px;
  }
}
.save{
  display: flex;
  justify-content: center;
  padding-top: 20px;
}
</style>